import { observable, action } from "mobx";
import { LeagueInfo } from "sb-resp-lib";

export type MultiViewLeagueType = {

    eventIds: string[];
    id: string;
    name: string;
    sortId: number;
    rankId: number;
    countryName: string;
    masterLeagueId: string;
    urlCode: string;
}

export class MultiViewLeagueInfo extends LeagueInfo {
    @observable eventIds: string[];

    constructor(leagueData: MultiViewLeagueType) {
        super(leagueData);
        this.eventIds = leagueData.eventIds;
    }

    @action.bound addEventId(id: string) {
        this.eventIds.push(id);
    }
}